export default __webpack_public_path__ + "static/media/tommie_profile.b25649eb.jpg";